import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Comentario, Comentarios, ItemTip, User } from '../../app/interfaces';
import { LoginProvider } from '../../providers/login/login';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the EditarComentarioComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'editar-comentario',
  templateUrl: 'editar-comentario.html'
})
export class EditarComentarioComponent {

  comentario: Comentarios;
  comentarioTexto: string;
  itemTip: ItemTip;
  user: User;

  constructor(public viewCtrl: ViewController,
              public navCtrl: NavController,
              public toastCtrl: ToastController,
              private restApi: RestApiProvider,
              private _loginProvider: LoginProvider,
              public navParams: NavParams) 
  {
    this.comentario = this.navParams.get('comentario');
    if (!this.comentario) {
      return;
    }
    this.itemTip = this.navParams.get('itemTip');
    if (!this.itemTip) {
      this.itemTip = {title: '', id: 0};
      this.navCtrl.setRoot('TabTipsPage');
    }
  }

  ionViewWillEnter() {
    this._loginProvider.user.subscribe((user: User) => {
      this.user = user;
    });
  }

  postComentarioEditado(comentarioTexto: Comentario) {
    if (!comentarioTexto) {
      return;
    }
    this.restApi.editarComentario(comentarioTexto, this.itemTip, this.user, 
      this.comentario)
      .subscribe((response: any) => { 
          const toast = this.toastCtrl.create({
            message: 'Comentario editado',
            duration: 2000
          });
          toast.present();
    });
    this.cancelar();
  }

  cancelar() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/editar-comentario/editar-comentario.ts